import { useMutation } from 'react-query';
import CompanyService from 'App/services/CompanyService';

const useActivityMobileLinksPresignedUrl = () => {
    return useMutation(({ branchId, downloadId }) =>
        CompanyService.getActivityMobileLinksPresignedUrl(branchId, downloadId)
    );
};

export default useActivityMobileLinksPresignedUrl;
